export default __webpack_public_path__ + "88fe4a767e717ffe085b8ca198897f7a.svg";